import { IonToast } from '@ionic/react'
import React from 'react'

import { ToastProps } from 'react-toast-notifications'

export const Toast = ({ children, autoDismissTimeout }: ToastProps) => {
  return <IonToast color="secondary" isOpen={true} message={children?.toString()} duration={autoDismissTimeout} />
}
